// What's New announcements
// Update this array whenever a major user-facing feature ships.
// The top entry is shown in the dismissible HomePage banner (until user dismisses).
// Keep the id unique — changing it triggers the banner to show again for returning users.

export const WHATS_NEW = [
  {
    id: '2026-02-share-preview',
    title: 'Share link previews now show the LIVE score',
    blurb: 'Send the live-scoreboard link to family — iMessage/Slack/WhatsApp previews now show "Tigers 3, Bears 2 · Top 4" right in the card. Every link turns into a hype moment. No download required — tap and watch.',
    cta: null,
    icon: 'share-2',
  },
  {
    id: '2026-02-parent-forecast',
    title: 'Weather forecast now on Parent & Live views',
    blurb: 'Grandma taps the live scoreboard link and sees the exact same game-day weather coaches see on their phone. No install needed.',
    cta: null,
    icon: 'cloud',
  },
  {
    id: '2026-02-per-game-forecast',
    title: 'Live per-game forecast on every card',
    blurb: 'Every upcoming game inside the 7-day window shows weather at a glance — icon, high/low temp, and rain % — right under the date. No more flipping between apps on game morning.',
    cta: null,
    icon: 'cloud',
  },
];

export const LATEST_WHATS_NEW = WHATS_NEW[0];
